import React from "react";

/**
 * Minimal-line sparkline. No axes, no dots.
 * Points marked `forecast: true` render as a dashed segment.
 */
export default function Sparkline({ points, width = 340, height = 56, color = "#8B1E1E", forecastColor = "#C49A4A" }) {
  if (!Array.isArray(points) || points.length < 2) return null;

  const values = points.map((p) => Number(p.y) || 0);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;

  const stepX = (width - 8) / (points.length - 1);
  const norm = (v) => height - 4 - ((v - min) / range) * (height - 8);

  const coords = points.map((p, i) => ({
    x: 4 + i * stepX,
    y: norm(Number(p.y) || 0),
    forecast: !!p.forecast,
  }));

  const solidPath = [];
  const dashPath = [];
  for (let i = 0; i < coords.length - 1; i++) {
    const a = coords[i];
    const b = coords[i + 1];
    const seg = `M${a.x.toFixed(1)} ${a.y.toFixed(1)} L${b.x.toFixed(1)} ${b.y.toFixed(1)}`;
    if (a.forecast || b.forecast) dashPath.push(seg);
    else solidPath.push(seg);
  }

  return (
    <svg
      width="100%"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      data-testid="assistant-sparkline"
      aria-label="trend chart"
      style={{ display: "block" }}
    >
      {solidPath.length > 0 && (
        <path d={solidPath.join(" ")} fill="none" stroke={color} strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" />
      )}
      {dashPath.length > 0 && (
        <path
          d={dashPath.join(" ")}
          fill="none"
          stroke={forecastColor}
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="3 3"
        />
      )}
    </svg>
  );
}
